import React from 'react';

interface LoadingOverlayProps {
  isLoading: boolean;
}

/**
 * A loading overlay component that displays a spinner and loading message
 * when the isLoading prop is true.
 */
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading }) => {
  if (!isLoading) return null;
  
  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      zIndex: 1000,
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px'
      }}>
        <div style={{
          width: 50,
          height: 50,
          borderRadius: '50%',
          border: '4px solid #e0e0e0',
          borderTopColor: '#3498db',
          animation: 'cliploader-spin 0.75s linear infinite',
        }} />
        <style>{`@keyframes cliploader-spin { to { transform: rotate(360deg); } }`}</style>
        <div>Loading graph...</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
